/* eslint-disable */
import { Axios } from "../../services/axios";
import download from "downloadjs";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { CloseIcon } from "../../assets/Icons";
import Loader from "../../components/ui/Loader";
import {
  getTransactionSummary,
  getVendorCodes,
  initializeTransaction,
  veryifyDualTrxn,
} from "../../services/review";
import { getRemitterDetails } from "../../services/userDetails";
import {
  isEsigned,
  recipientDetails,
  transactionDetails,
  userDetails,
  vendorCodes,
  transactionId,
  roundOffValue,
  selectVendor,
  timerState,
  panDeclaration,
} from "../../store";
import { RecipientDetails, UserTransactionDetails } from "../../store/store";
import { Calculation } from "./Calculation";
import { Modals } from "./Modals";
import { PaymentOverview } from "./PaymentOverview";
import { RemittanceDetails } from "./RemittanceDetails";
import { getCurrentIP } from "../../utils";
import { getContent, getSignedStatus, signLaterStatus } from "../../services/reviewPage";
import EsignModal from "./EsignModal";
import DeclarationModal from "./DeclarationDetailModal";
import { urlencoded } from "express";
import ContentModal from "./ContentModal";
import MixpanelConfig from "../../constants/MixpanelConfig";

const Review = () => {
  const [taxStep, stepTaxStep] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [thisRecipient, setThisRecipient] = useState<any>();
  const [transactionNumber, setTransactionNumber] = useRecoilState(transactionId);
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const vendorUserDetails = JSON.parse(localStorage.getItem("vendorUserDetails") || "{}");
  const userId = localStorage.getItem("vendorUserKey") || "";
  const [transactionData, setTransactionData] = useRecoilState(transactionDetails);
  const recipientData: RecipientDetails = useRecoilValue(recipientDetails);
  const recipientId = localStorage.getItem("recipient_id");
  const [userData, setUserData] = useRecoilState(userDetails);
  const [dualNumber, setDualNumber] = useState<string>("");
  const [dualVerified, setDualVerified] = useState<boolean>(false);
  const [sourceOfFunds, setSourceOfFunds] = useState("");
  const [dualError, setDualError] = useState<string>("");
  const [referrer, setReferrer] = useState<string>("");
  // const [vendorCodes, setVendorCodes] = useState<any>([]);
  const [currentIP, setCurrentIP] = React.useState("");
  // const vendorUserKey = localStorage.getItem("userVendorKey")
  const [vendorKeyUser, setVendorKeyUser] = React.useState("");
  const [signA2FormStatus, setSignA2FormStatus] = React.useState<boolean>(false);
  const eSignStatus = useRecoilState(isEsigned)[0];
  const [isEsignModal, setIsEsignModal] = React.useState<boolean>(false);
  const [isDeclarationModal, setDeclarationModal] = React.useState<boolean>(true);
  const [eSign, setEsign] = React.useState<boolean>(false);
  const [signLater, setSignLater] = React.useState<boolean>(false);
  const [linkSent, setLinkSent] = React.useState<boolean>(false);
  const vendorCode = useRecoilValue(selectVendor);
  const [A2errorMessage, A2setErrorMessage] = useState("");
  const [a2Link, setA2Link] = useState<string>("");
  const [isViewingA2Form, setIsViewingA2Form] = useState(false);
  const referrerVendorCode = useRecoilValue(selectVendor);
  const roundOffVal = useRecoilValue(roundOffValue);
  const stopTimer = useSetRecoilState(timerState);
  const panDeclarationValue = useRecoilValue(panDeclaration);
  const [contentData, setContentData] = useState<any>(null);
  const [isContentModalOpen, setIsContentModalOpen] = useState(false);
  const [consentCheckbox, setConsentCheckbox] = useState(false);


  const apiUrl = process.env.REACT_APP_SERVER_ID_MERGER;

  const hasFetchedRef = useRef(false);

  const isPurposeCodeValid =
    transactionData?.purposeCode === "S1301" || transactionData?.purposeCode === "S1302"
      ? true
      : false;

      useEffect(() => {
        setVendorKeyUser(localStorage.getItem("vendorUserKey") || "{}");
        const lanMandatoryCheck = localStorage.getItem("lanMandatory");
      }, []);

  // useEffect(() => {
  //   localStorage.removeItem("declareAmount")
  // },[])

  useEffect(() => {
    localStorage.removeItem("declareAmount")
  }, [])

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      sessionStorage.setItem("navigatingFromPage", "true");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const shouldNavigate = sessionStorage.getItem("navigatingFromPage") === "true";
      if (shouldNavigate) {
        sessionStorage.removeItem("navigatingFromPage");
        navigate("/remittance", { replace: true });
      }
    }, 500);
  }, [navigate]);

  useEffect(() => {
    if (eSignStatus.signed && eSignStatus.signedLater) {
      setSignA2FormStatus(true);
    } else {
      setSignA2FormStatus(false);
    }
  }, []);

  const handleSignA2Form = () => {
    setIsEsignModal(true);
  };

  const handleDoLaterA2Form = () => {
    const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
    signLaterStatus({
      userId: vendorUserKey,
    })
      .then((response) => {
        if (response) {
          setIsEsignModal(false);
        }
      })
      .catch((error) => {
        alert(error?.response?.data?.error?.type);
      });
  };
  const handleLinkSent = () => {
    setIsEsignModal(false);
    setLinkSent(true);
  };

  useEffect(() => {
    handleEsignedStatus();
  }, [isEsignModal]);

  const handleEsignedStatus = () => {
    const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
    getSignedStatus({
      userId: vendorUserKey,
    })
      .then((response) => {
        setSignLater(response?.data?.signedLatter);
        setEsign(response?.data?.signed);
        setLinkSent(response?.data?.signLinkSent);
        setA2Link(response?.data?.link)
      })
      .catch((error) => {
        console.error(error?.response?.data?.error?.type);
      });
  };

  useEffect(() => {
    getRemitterDetails(currentUser).then((response: any) => {
      setUserData(response?.data);
    });

    getCurrentIP()
      .then((response) => {
        setCurrentIP(response.data.IPv4);
      })
      .catch((error: any) => {
        console.error("Geo location API failed", error);
      });
  }, [vendorKeyUser]);


  const getCodes = () => {
    getVendorCodes(currentUser).then((response: any) => {
      const codeArray: string[] = [];
      response.data.forEach((element: any) => {
        codeArray.push(element.value);
      });
      // setVendorCodes(codeArray);
    });
  };
  useEffect(() => {
    getCodes();
  }, []);
  const isEducation: any = localStorage.getItem("isEducation");

  const handleClose = () => {
    setIsModalOpen("cancel");
  };

  const onChangeHandlerType = localStorage.getItem("onChangeHandler") || "send";

  const handleGetContent = async () => {
    try {
      if (!currentUser?.idToken) return;
      const res = await getContent(currentUser, "KNOW_MORE");
      if (res?.data) {
        setContentData(JSON.parse(res.data.contentJson));
      } else {
        console.error("No data received from API");
      }
    } catch (error) {
      console.error("Failed to fetch content", error);
    }
  };

   useEffect(() => {
    handleGetContent();
  }, []);

  useEffect(() => {
    if (hasFetchedRef.current) return;

    const declaredAmount = localStorage.getItem("declareAmount");
    setLoading(true);

    const body = {
      ...(onChangeHandlerType === "send"
        ? { user_send: transactionData?.user_send ?? 0 }
        : { reciepient_recieve: transactionData?.reciepient_recieve ?? 0 }),
      transVendorKey: vendorCode?.userId,
      dest_currency: transactionData?.dest_currency,
      base_currency: "INR",
      hop_coins: transactionData?.hop_coins,
      mgr_initial: transactionData?.mgr_initial,
      purposeCode: transactionData?.purposeCode,
      conversion_rate: transactionData?.conversion_rate ?? 0,
      vendor_key: currentUser?.vendor_key,
      userId: userId,
      isBene: transactionData?.isBene === null ? false : transactionData?.isBene,
      isEducation: isEducation,
      transaction_purpose: transactionData?.transaction_purpose,
      declare_amount: declaredAmount,
      pan_number: panDeclarationValue,
    };

    getTransactionSummary(body)
      .then((response: any) => {
        setLoading(false);
        const success = response?.data;
        if (success) {
          setTransactionData((prev) => {
            const merged = {
              ...prev,
              ...response?.data,
              // transactionLeadIds: {
              //   ...prev.transactionLeadIds,
              //   // ...(response?.data?.transactionLeadIds || {}),
              // },
              transactionLeadIds: {
                ...prev.transactionLeadIds,
                ...(response?.data?.transactionLeadIds || {}),
              },

            };
            return merged;
          });
          hasFetchedRef.current = true;
        } else {
          setErrorMessage(response?.data?.error?.type);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        console.error(error);
      });
  }, [transactionData, vendorCode, currentUser]);

  const handleInitializeTransaction = (e: any) => {
    // setLoading(true);
    e.preventDefault();
    const body = {
      transVendorKey: vendorCode?.userId,
      advance_pay: 0,
      base_currency: transactionData.base_currency,
      cgst: transactionData.cgst,
      conversion_rate: transactionData.conversion_rate,
      dest_currency: transactionData.dest_currency,
      hop_fees: transactionData.hop_fees,
      igst_fees: transactionData.igst_fee,
      reciepient_recieve: transactionData.reciepient_recieve,
      service_tax: transactionData.service_tax,
      sgst: transactionData.sgst,
      tcs: transactionData.tcs,
      total_pay: transactionData.total_pay,
      total_tax: transactionData.total_tax,
      mgr_initial: transactionData.mgr_initial,
      transaction_purpose: transactionData.transaction_purpose,
      purposeCode: transactionData.purposeCode,
      transactionLeadIds: Object.values(transactionData?.transactionLeadIds),
      isA2FormConsent: true,
      user_send: transactionData.user_send,
      isAdvancePay: false,
      isFullPay: true,
      hop_coins: transactionData.hop_coins,
      isEducation: isEducation === "true" ? true : false,
      id_recipient: recipientId,
      conversion_amount: transactionData.conversion_amount,
      nostro_charges: transactionData.nostro_charges,
      nostro_charges_new: transactionData.nostro_charges_new,
      promo_code: transactionData.promo_code,
      promo_code_disount: transactionData.promo_code_discount,
      vendor_margin: transactionData.vendor_margin,
      vendor_key: currentUser.vendor_key,
      referrerVendor: referrerVendorCode?.vendorCode,
      isBene: transactionData.isBene === null ? false : transactionData.isBene,
      ipAddress: currentIP,
      sourceOfFunds: sourceOfFunds,
      trxnDeclarations: {
        ...(transactionData?.trxnDeclarations || {}),
        vendorCode: vendorCode?.vendorCode,
        lanNumber: transactionData?.trxnDeclarations?.lanNumber,
        paymentUtr: transactionData?.trxnDeclarations?.paymentUtr
      },
      nextDecimal: roundOffVal ? 10 : 0,
         consent: [{
        "store": true,
        "accepted": consentCheckbox,
        "pageName": "COMPLIANCE",
        "ipAddress": currentIP
      }] 
    };

    MixpanelConfig.trackEvent(MixpanelConfig.eventNames.Old_Review_Submit, { 
      transactionData: transactionData,
      formData: body
    });


    initializeTransaction(body)
      .then((response: any) => {
        localStorage.setItem("onlyNeft", String(isPurposeCodeValid));
        setLoading(false);
        setTransactionData((prev) => ({
          ...prev,
          ...response?.data,
          transactionLeadIds: {
            ...prev.transactionLeadIds,
            ...(response?.data?.transactionLeadIds || {}),
          },
        }));
        stopTimer(false);
        setTransactionNumber(response?.data?.transactionNumber);
        MixpanelConfig.trackEvent(response?.data?.transactionNumber, {
          formData: body,
          transactionNumber: response?.data?.transactionNumber,
          id_transaction: response?.data?.id_transaction,
          from: "OLD_RECOIL_STATE"
        });
        MixpanelConfig.trackEvent(MixpanelConfig.eventNames.Old_Review_Submit_Response, { 
          transactionData: transactionData,
          formData: body,
          responseData: response?.data,
          transactionNumber: response?.data?.transactionNumber
        });
        localStorage.removeItem("conversionRate");
        navigate("/payment", {
          state: {
            purpose: transactionData.purposeCode,
          },
        });
      })
      .catch((error: any) => {
        setErrorMessage(error?.response?.data?.error?.type);
        setLoading(false);
        console.error(error);
      });
  };


  useEffect(() => {
    const currentRecipient = recipientData?.filter((data: any) => {
      return data?.id == recipientId;
    });
    setThisRecipient(currentRecipient);
  }, []);

  const userToken = localStorage.getItem("userToken") || "";

  const handleA2Form = () => {
    const address1 = encodeURIComponent(`${userData.addressLine1}`);
    setLoading(true);
    Axios.get(
      `/remit/user/${localStorage.getItem("vendorUserKey") || "{}"}/generateA2Form/?city=${userData.city
      }&dest_curr=${transactionData?.dest_currency}&pan_num=&pincode=${userData.pinCode
      }&purpose_code=${transactionData?.purposeCode}&purpose_description=${transactionData?.transaction_purpose
      }&reciepient_recieve=${transactionData?.reciepient_recieve}&recipeint_accnt_num=${thisRecipient[0].bankAccountNumber
      }&recipient_bank_name=${thisRecipient[0]?.bankName}&recipient_first_name=${thisRecipient[0].firstName
      }&recipient_last_name=${thisRecipient[0].lastName}&reicpient_bank_accnt_country=${thisRecipient[0].bankAccountCountry
      }&state=${thisRecipient[0].bankAccountCountry}&total_pay=${transactionData?.total_pay
      }&user_address1=${address1}&user_first_name=${userData.firstName}&user_last_name=${userData.lastName
      }&recipientId=${recipientId}&bene=${(transactionData?.purposeCode === "S1301" || transactionData?.purposeCode === "S1302") ??
      true
      }`,
      {
        headers: {
          "Access-Control-Allow-Origin": "true",
          "Content-Type": "application/pdf",
          Authorization: `${userToken}`,
        },
        responseType: "blob",
      },
    )
      .then((response) => {
        setLoading(false);
        A2setErrorMessage("");
        const content = response.headers["content-type"];
        download(response.data, "download_A2.pdf", content);
      })
      .catch((error) => {
        console.error("Error", error);
        setLoading(false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.type
        ) {
          const errorMessage = error.response.data.error.type;
          A2setErrorMessage(errorMessage);
        } else {
          A2setErrorMessage("An unexpected error occurred in Downloading A2.");
        }
      });
  };

  const viewA2Form = () => {
    setIsViewingA2Form(true);
    const address1 = encodeURIComponent(`${userData.addressLine1}`);

    Axios.get(
      `/remit/user/${localStorage.getItem("vendorUserKey") || "{}"}/generateA2Form/?city=${userData.city
      }&dest_curr=${transactionData?.dest_currency}&pan_num=&pincode=${userData.pinCode
      }&purpose_code=${transactionData?.purposeCode}&purpose_description=${transactionData?.transaction_purpose
      }&reciepient_recieve=${transactionData?.reciepient_recieve}&recipeint_accnt_num=${thisRecipient[0].bankAccountNumber
      }&recipient_bank_name=${thisRecipient[0].bankName}&recipient_first_name=${thisRecipient[0].firstName
      }&recipient_last_name=${thisRecipient[0].lastName}&reicpient_bank_accnt_country=${thisRecipient[0].bankAccountCountry
      }&state=${thisRecipient[0].bankAccountCountry}&total_pay=${transactionData?.total_pay
      }&user_address1=${address1}&user_first_name=${userData.firstName}&user_last_name=${userData.lastName
      }&recipientId=${recipientId}&bene=${(transactionData?.purposeCode === "S1301" || transactionData?.purposeCode === "S1302") ??
      true
      }`,
      {
        headers: {
          "Access-Control-Allow-Origin": "true",
          "Content-Type": "application/pdf",
          Authorization: `${userToken}`,
        },
        responseType: "blob",
      },
    )
      .then((response) => {
        A2setErrorMessage("");
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");
        setIsViewingA2Form(false);
      })
      .catch((error) => {
        setIsViewingA2Form(false);
        setLoading(false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.type
        ) {
          const errorMessage = error.response.data.error.type;
          A2setErrorMessage(errorMessage);
        } else {
          A2setErrorMessage("An unexpected error occurred in Viewing A2.");
        }
      });
  };

  const verifyDual = () => {
    veryifyDualTrxn(currentUser, dualNumber)
      .then((response) => {
        if (response?.data === "correct") {
          setDualVerified(true);
        }
      })
      .catch((error) => {
        setDualError(error?.response?.data?.error?.type);
        setDualVerified(false);
        setTimeout(() => {
          setDualError("");
        }, 3500);
      });
  };

  return (
    <div className="w-full max-w-[1120px] ml-[8%] -mt-4">
      {loading === false ? (
        <div>
          <div id="header" className="flex items-center justify-between mt-5">
            <span className="text-[30px] font-semibold font-ssp">Review</span>
          </div>
          <div id="content" className="flex h-[1000px] gap-7">
            <div id="left" className="flex flex-col items-start w-[44%]">
              <RemittanceDetails />
              <Calculation taxStep={true} setTaxStep={stepTaxStep} />
            </div>
            <div className="border-l-4 h-[580px] border-gray-300"></div>
            <div id="right" className="flex flex-col items-center w-1/2">
              <div className="">
                <PaymentOverview
                  handleClick={handleInitializeTransaction}
                  handleA2Form={handleA2Form}
                  errorMessage={errorMessage}
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  dualNumber={dualNumber}
                  setDualNumber={setDualNumber}
                  verifyDual={verifyDual}
                  dualError={dualError}
                  dualVerified={dualVerified}
                  referrer={referrer}
                  setReferrer={setReferrer}
                  // vendorCodes={vendorCodes}
                  signA2FormStatus={signA2FormStatus}
                  handleSignA2Form={handleSignA2Form}
                  eSign={eSign}
                  signLater={signLater}
                  linkSent={linkSent}
                  viewA2Form={viewA2Form}
                  isViewingA2Form={isViewingA2Form}
                  A2errorMessage={A2errorMessage}
                  sourceOfFunds={sourceOfFunds}
                  setSourceOfFunds={setSourceOfFunds}
                  setErrorMessage={setErrorMessage}
                  contentData={contentData}
                  setIsContentModalOpen={setIsContentModalOpen}
                  setConsentCheckbox={setConsentCheckbox}
                  consentCheckbox={consentCheckbox}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center w-[500px] h-[500px] ml-[450px] mt-[150px]">
          <Loader />
        </div>
      )}
      <Modals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      <ContentModal isTermsModalOpen={isContentModalOpen} setIsTermsModalOpen={setIsContentModalOpen} contentData={contentData} />
      <EsignModal
        handleA2Form={handleA2Form}
        isEsignModal={isEsignModal}
        a2Link={a2Link}
        setIsEsignModal={setIsEsignModal}
        handleDoLaterA2Form={handleDoLaterA2Form}
        handleLinkSent={handleLinkSent}
        viewA2Form={viewA2Form}
        isViewingA2Form={isViewingA2Form}
        setIsViewingA2Form={setIsViewingA2Form}
        A2errorMessage={A2errorMessage}
        A2seterrorMessage={A2setErrorMessage}
      />
      {/* <DeclarationModal
        isDeclarationModal={isDeclarationModal}
        setDeclarationModal={setDeclarationModal}
      /> */}
    </div>
  );
};

export default Review;
